import { gridFlexStyle } from '@bingads-webui-campaign-react/grid-flex-style';

export function getStyles(_, { palette = {} }) {
  return {
    seasonalityTablePageContainer: {
      '& .toolbar .contextual-dropdown .btn-primary': {
        height: '32px',
        padding: '0 20px',
        '& .iconba-Add': {
          color: '#fff',
        },
      },
      '& .search-box': {
        width: '300px',
      },
      '& .popover': {
        maxWidth: 'fit-content',
      },
      '& .conversion-rate-adjustment-view': {
        '& .form-inline .form-group': {
          display: 'block',
        },
        '& .conversion-rate-adjustment-input-group': {
          marginLeft: '10px',
        },
        '& .input-group .form-control': {
          borderRightColor: 'transparent',
        },
      },
    },
    seasonalityGridViewContainer: {
      // In the first column (selection column), hide redundant radio buttons
      '& .tbody .tr .td[data-column="selection"] > input': {
        '&:before': {
          content: 'none',
        },
        '&:after': {
          content: 'none',
        },
      },
    },
    '@global': {
      ...gridFlexStyle({ palette }),
    },
  };
}
